import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Nullable, WorkspaceMeta } from "@msuite/utils/types";
import { client } from "@/hono";
import { useRemoteFileUrl } from "@/hooks/use-remote-file-url";

export function useWorkspaceMediaDefault(workspaceId: Nullable<string>) {
	const { data: meta } = useQuery({
		queryKey: ["workspace-meta", workspaceId ?? ""],
		queryFn: async () => {
			if (!workspaceId) return null;
			const response = await client.organizations.workspaces[":workspaceId"].meta.$get({
				param: { workspaceId },
			});
			const data = await responseHandler(response as any);
			return data.workspaceMeta as WorkspaceMeta;
		},
	});

	const { signedUrl: workspaceLogoUrl } = useRemoteFileUrl(
		meta?._media.find((m) => m.type === "logo")?._file ?? null,
	);
	const { signedUrl: workspaceLetterpaperUrl } = useRemoteFileUrl(
		meta?._media.find((m) => m.type === "letter-paper")?._file ?? null,
	);

	return {
		workspaceLogoUrl,
		workspaceLetterpaperUrl,
	};
}
